import {
	Box,
	Button,
	FormControl,
	FormErrorMessage,
	Heading,
	Image,
	InputGroup,
	Text,
} from "@chakra-ui/react";
import Input from "../components/inputs/Input";
import { Center, Flex } from "@chakra-ui/layout";
import loginImage from "../assets/login.png";
import Logo from "../components/Logo";
import PrimaryButton from "../components/PrimaryButton";
import { FieldValues, FormProvider, useForm } from "react-hook-form";
import { NavLink, useNavigate } from "react-router-dom";
import PasswordInput from "../components/inputs/PasswordInput";
import StlLoader from "../components/StlLoader";
import { useQueryParams } from "../hooks/utils.hooks";
import { useEffect } from "react";
import { useMutation } from "react-query";
import { invitationLink } from "../mutations/auth.mutations";
import { MutateErrors, mutateOnError } from "../lib/generic";

function InvitationLoginPage() {
	const methods = useForm();
	const navigate = useNavigate();
	const { token } = useQueryParams();
	const { mutate: mutateInvitationLink } = useMutation(invitationLink, {
		onSuccess: () => {
			navigate("/login");
		},
		onError: (err: MutateErrors) => {
			methods.setError("email", {
				message: "Erreur d'email ou de mot de passe.",
			});
			methods.setError("password", {
				message: "Erreur d'email ou de mot de passe.",
			});
			mutateOnError(err);
		},
	});

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const onSubmit = async (data: FieldValues) => {
		const valid = await methods.trigger();
		if (valid) {
			mutateInvitationLink({
				token,
				email: data.email,
				password: data.password,
			});
		}
	};

	useEffect(() => {
		if (!token) {
			navigate("/login");
		}
	}, [navigate, token]);
	return (
		<Flex>
			<Box display={{ base: "none", lg: "block" }}>
				<StlLoader
					alternative={
						<Image
							src={loginImage}
							alt="Dan Abramov"
							h="100vh"
							w="50vw"
							display={{ base: "none", lg: "block" }}
						/>
					}
				></StlLoader>
			</Box>
			<Center w="100%">
				<Flex
					direction="column"
					alignItems="left"
					justifyContent="center"
					h="100vh"
					w="50vw"
					px={{ base: "44px", md: "144px" }}
				>
					<Flex direction="column" alignItems="center">
						<Logo />
						<Heading
							fontWeight={600}
							fontSize="32px"
							lineHeight="48px"
							color="gray.900"
							whiteSpace={"nowrap"}
						>
							Vous avez été invité à rejoindre un centre
						</Heading>
						<Text
							fontWeight={400}
							fontSize="20px"
							lineHeight="30px"
							color="gray.600"
							textAlign="center"
							display={{ base: "none", sm: "block" }}
						>
							Remplissez ce formulaire
						</Text>
					</Flex>
					<FormProvider {...methods}>
						<form
							style={{ marginTop: "32px" }}
							onSubmit={methods.handleSubmit((data) => onSubmit(data))}
						>
							<FormControl
								mt="10px"
								isInvalid={!!methods.formState.errors.email}
							>
								<Input
									id="email"
									placeholder="Email"
									{...methods.register("email", {
										required: "Ce champ est obligatoire",
									})}
								></Input>
								<FormErrorMessage>
									<>{methods.formState.errors?.email?.message}</>
								</FormErrorMessage>
							</FormControl>

							<FormControl
								mt="10px"
								isInvalid={!!methods.formState.errors.password}
							>
								<InputGroup size="md">
									<PasswordInput
										pr="4.5rem"
										placeholder="Mot de passe"
										{...methods.register("password", {
											required: "Ce champ est obligatoire",
										})}
									/>
								</InputGroup>
								<FormErrorMessage>
									<>{methods.formState.errors?.email?.message}</>
								</FormErrorMessage>
							</FormControl>

							<PrimaryButton mt="10px" type="submit">
								Rejoindre le centre
							</PrimaryButton>
						</form>
					</FormProvider>
					<Center my="24px">
						Pas de compte ?&nbsp;
						<Button variant="link" color="brand.700">
							<NavLink to={`/invitation?token=${token}`}>
								Créer un nouveau compte
							</NavLink>
						</Button>
					</Center>
				</Flex>
			</Center>
		</Flex>
	);
}

export default InvitationLoginPage;
